export default{
    getLoad(state){
        return state.load;
    }
}